<template>
  <div class="guest">
    <h5 class="guest__title">Viaggiatore principale</h5>
    <loader v-if="loading" />
    <validation-observer
      v-if="!loading"
      v-slot="{ invalid }"
      ref="observer"
    >
      <!-- se allowCustomBeneficiary==false allora nome, cognome, codice fiscale vanno estrapolati dal beneficiario scelto nella select -->
      <div v-show="!allowCustomBeneficiary">
        <!-- label class="vb-label mt-0" v-html="'Viaggiatore principale'" /-->
        <vb-select
          v-model="beneficiaryId"
          @change="update_beneficiary()"
          :vb_options="{
            required: true,
            options: beneficiaries,
          }"
        />
      </div>

      <validation-provider
        class="guest__group-input"
        v-for="(field,key) in guest"
        v-bind:key="'input_'+key"
        :rules="field.rules"
        :name="key"
        :vid="key"
        v-slot="{ errors, validate, failedRules }"
      >

        <!-- se allowCustomBeneficiary==false allora nome, cognome vanno inseriti a mano -->
        <template v-if="['guestFirstName','guestLastName', 'guestEmail'].includes(key)">
          <!--TODO: is_development() mostra i campi anche se allowCustomBeneficiary==false, serve solo per i primi rilasci in test-->
          <template v-show="allowCustomBeneficiary || is_development()">
            <label class="vb-label" v-html="field.name" />
            <vb-input
              @input="validate_fields($event,validate,key)"
              @change="validate_fields($event,validate,key)"
              @blur="validate_fields($event,validate,key)"
              v-model="guest[key].value"
              :vb_options="{
                name: key,
                disabled: !allowCustomBeneficiary,
              }"
            />
            <!--<span class="vee--errors">{{ errors[0] }}</span>-->
            <div v-for="(rule,index) in failedRules" v-bind:key="_uid+index">
              <span v-if="index!=='required'" class="vee--errors">{{ rule.replace(key, field.name) }}</span>
            </div>
          </template>
        </template>

        <template v-else-if="field.type === 'select'">
          <label class="vb-label" v-html="field.name" />
          <vb-select
            v-model="guest[key].value"
            @change="validate_fields($event,validate,key)"
            :vb_options="{
              options: field.options,
            }"
          />
        </template>

        <template v-else-if="field.type === 'input'">
          <label class="vb-label" v-html="field.name" />
          <vb-input
            @input="validate_fields($event,validate,key)"
            @change="validate_fields($event,validate,key)"
            @blur="validate_fields($event,validate,key)"
            v-model="guest[key].value"
            :vb_options="{
              name: key,
            }"
          />
          <!--<span class="vee--errors">{{ errors[0] }}</span>-->
          <div v-for="(rule,index) in failedRules" v-bind:key="_uid+index">
            <span v-if="index!=='required'" class="vee--errors">{{ rule.replace(key, field.name) }}</span>
          </div>
        </template>

        <template v-else-if="field.type === 'checkbox'">
          <vb-checkbox
            v-model="guest[key].value"
            @change="validate_fields($event,validate,key)"
            :vb_options="{
              name: key,
              text: '<p>'+field.text+'</p>',
              type: 'light',
            }"
          />
          <!--<span class="vee--errors">{{ errors[0] }}</span>-->
        </template>

      </validation-provider>
    </validation-observer>
  </div>
</template>

<script>
import { service_handler } from '@/services'
import * as Validation from '@resources/validation'
import {
  map_beneficiaries_response,
  map_beneficiary_relations,
  find_beneficiary_by_id,
  extract_guest_fields_from_beneficiary,
  get_default_beneficiary_id
} from './logic'

export default {
  name: "sidebar-guest",

  props: {
    validate_on_mount: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      loading: true,
      beneficiaryId: '', // default vuoto, non cambiare, viene usato al checkout, setBeneficiaryById
      beneficiaries: [],
      allowCustomBeneficiary: false,
      beneficiaryRelations: [],
      guest: {
        guestFirstName: Validation.first_name,
        guestLastName: Validation.last_name,
        guestEmail: Validation.email,

        // TODO b2c gerry
        /*guestAddress: Validation.address,
        guestCity: Validation.city,
        guestProvince: Validation.province,*/

        guestPhonePrefix: Validation.phone_prefix,
        guestPhone: Validation.phone,
      }
    }
  },

  mounted() {

    this.handle_beneficiaries()
    .then( () => {
      this.emit_results(false)
      /* validazione resettata dopo chiamata ai beneficiari (serviva solo per avere il pulsante "Continua" attivo nel caso in cui il browser autocompletasse i campi, ma non è necessario perché comunque le checkbox vanno spuntate a mano)
      this.$nextTick(() => {
        this.$refs.observer.validate().then(res => {
          let payload = res ? this.get_payload() : false
          this.emit_results(payload)
        })
      })
      */
    })

    // in caso di 500 alla book, <sidebar /> forza dall'alto la ri-validazione dei campi per evitare che il pulsante di acquisto resti disabilitato
    // per farlo, ho bisogno di attendere che this.$refs.observer sia disponibile
    if (this.validate_on_mount) {
      let timer = setInterval(() => {
        if (this.$refs.observer) {
          clearInterval(timer)
          this.$refs.observer.validate().then(res => {
            let payload = res ? this.get_payload() : false
            this.emit_results(payload)
          })
        }
      }, 500)
    }
  },

  watch: {
    guest: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          if (!this.$refs.observer) return
          this.$refs.observer.validate().then(res => {
            let payload = res ? this.get_payload() : false
            this.emit_results(payload)
          })
        })
      }
    }
  },

  methods: {
    async validate_fields(value, validate, name) {
      await validate(value).then(res => {
        if (!res.valid) {
          this.emit_results(false)
          return
        }

        let fields = this.$refs.observer.fields

        for (let index = 0; index < Object.keys(fields).length; index++) {
          const key = Object.keys(fields)[index]
          if (key === name) continue
          if (!fields[key].valid) {
            this.emit_results(false)
            return
          }
        }
        this.emit_results(this.get_payload())
      })
    },

    update_beneficiary() {
      const beneficiary = find_beneficiary_by_id(this.beneficiaries, this.beneficiaryId)
      const fields = extract_guest_fields_from_beneficiary(beneficiary)

      this.guest.guestFirstName.value = fields.firstName
      this.guest.guestLastName.value = fields.lastName
      this.guest.guestEmail.value = fields.email

      // Notifica sidebar del cambio beneficiario (usato da sidebar-bill-to-pax)
      this.$emit('change', { name: 'beneficiary-change', payload: this.beneficiaryId })

      this.$nextTick( () => {
        if (!this.$refs.observer) return
        this.$refs.observer.validate().then(res => {
          this.log(res)
          let payload = res ? this.get_payload() : false
          this.emit_results(payload)
        })
      })
    },

    get_payload() {
      let fields = this.$refs.observer.fields,
          payload = {}
      for (let index = 0; index < Object.keys(fields).length; index++) {
        const key = Object.keys(fields)[index]
        payload = {
          ...payload,
          [key]: this.guest[key].value
        }
      }
      if(!this.allowCustomBeneficiary) payload.beneficiaryId = this.beneficiaryId

      return payload
    },

    emit_results(payload) {
      this.$emit('change', {
        name: 'guest-update',
        payload: payload,
        traveler_fields: {
          firstName: this.guest.guestFirstName.value,
          lastName: this.guest.guestLastName.value,
        }
      })
    },

    handle_beneficiaries() {
      return service_handler('beneficiaries', {
        token: this.$config.token,
        routeName: this.$route.name,
      })
      .then(
        (success) => {
          this.allowCustomBeneficiary = success.data.allowCustomBeneficiary

          // Usa le funzioni pure per mappare i dati
          this.beneficiaries = map_beneficiaries_response(success.data.beneficiaries)

          if (this.allowCustomBeneficiary) {
            this.beneficiaryRelations = map_beneficiary_relations(success.data.beneficiaryRelations)
          }

          // Seleziona il primo beneficiario e aggiorna i campi guest
          const defaultId = get_default_beneficiary_id(this.beneficiaries)
          if (defaultId) {
            this.beneficiaryId = defaultId
            this.update_beneficiary()
          }

          this.loading = false
        },
        (error) => {
          this.log('[beneficiaries] - error')
          this.log(error.response)
        }
      )
    },

  }
}
</script>

<style lang="scss" scoped>

  .guest {
    &__title {
      @extend %sidebar__title;
    }

    &__group-input {
      @extend %sidebar__group-input;
    }
  }

</style>